<template>
  <div class="ccui-app-container-detail-body">
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      label-width="200px"
      class="ccui-form"
    >
      <el-form-item
        label="路线标题："
        prop="spuTitle"
        style="margin-bottom:15px"
      >
        <!-- 联塑（ LESSO）PVC排水管 D25 -->
        <el-input
          v-model="form.spuTitle"
          maxlength="100"
          class="input-long"
          clearable
          placeholder="请输入路线标题"
        />
      </el-form-item>
      <div class="title-input-message">
        <p class="explain first-explain">
          路线标题规范：路线标题需要包含路线、车型、路线分类、车型名称等
        </p>
        <p class="explain">
          例1：湖北省武汉市至北京市 货物重卡托运公路运输服务
        </p>
      </div>
      <el-form-item label="路线标语：" style="margin-bottom:15px">
        <el-input
          maxlength="100"
          v-model.trim="form.spuPromo"
          class="input-long"
          clearable
          placeholder="请输入路线标语"
        />
      </el-form-item>

      <div class="title-input-message">
        <p class="explain first-explain">
          路线标语最多输入100个字符，可以是路线卖点、相关热搜词等
        </p>
      </div>
      <el-form-item label="路线关键字：" style="margin-bottom:15px">
        <div class="keywords">
          <el-tag
            :key="index"
            v-for="(tag, index) in dynamicTags"
            closable
            :disable-transitions="false"
            @close="handleClose(tag)"
          >
            {{ tag }}
          </el-tag>
          <el-input
            class="input-new-tag"
            v-if="inputVisible"
            v-model="inputValue"
            ref="saveTagInput"
            maxlength="10"
            size="small"
            @keyup.enter.native="handleInputConfirm"
            @blur="handleInputConfirm"
          >
          </el-input>
          <el-button
            v-else-if="dynamicTags.length < 10"
            class="button-new-tag"
            size="small"
            @click="showInput"
            >+添加关键字
          </el-button>
        </div>
      </el-form-item>
      <div class="title-input-message">
        <p class="explain first-explain">
          最多允许输入10个路线关键字，您补充的关键字将有助于路线搜索精准度的提升。
        </p>
      </div>
      <el-form-item
        label="路线图片："
        prop="mainImg"
        style="margin-bottom:15px"
      >
        <el-button
          size="mini"
          type="default-mini"
          @click="reuseImg"
          v-if="uploadForm.length"
          >一键复用所有路线图片</el-button
        >
        <div @click="showSelectPicDialog($event)">
          <el-file-upload
            ref="upload"
            disabled
            :on-change="changeFile"
            :on-success="handleSuccess"
            :on-delete="onFileDelete"
            :data="upLoadData"
            :file-list="fileList"
            :before-upload="beforeAvatarUpload"
            :auto-upload="true"
            :limit="8"
            :action="importFileUrl"
            :headers="headers"
            file-ref="fileRef2"
            :picturePath="picturePath"
            :handlePictureCardPreview="handlePictureCardPreview"
          >
            <div slot="tip" class="el-upload__tip">路线主图</div>
          </el-file-upload>
        </div>
        <select-picture
          ref="selectPicture"
          :fileList.sync="fileList"
          type="mainSelect"
          reNodeName="selectPicture"
        ></select-picture>
      </el-form-item>
      <div class="title-input-message">
        <p class="explain first-explain">
          路线图片：需至少1张最多8张高清图片，第一张图片应放路线主图
        </p>
        <p class="explain first-explain">
          图片尺寸：最小324*324px，最大600*600px，图片需为正方形
        </p>
        <p class="explain first-explain">
          图片格式：支持jpg，bmp，gif，png，jpeg文件格式，大小不能超过5MB
        </p>
      </div>
      <el-form
        ref="skuImgList"
        label-width="200px"
        :model="skuForm"
        :rules="skuRules"
        :validate-on-rule-change="false"
      >
        <el-form-item
          v-for="(item, index) in uploadForm"
          :label="item + ' :'"
          :prop="'skuImgList' + index"
          :key="item"
          class="upload-list"
        >
          <el-button
            size="mini"
            type="default-mini"
            @click="reuseImgCell(index)"
            >使用路线图片</el-button
          >
          <FileUpload
            :ref="'upload' + index"
            :reuseImgList="reuseImgList"
            :reshows="reshows"
            :index="index"
            :reuseNeed="reuseNeed"
            :attr="item"
            :skuAllImg="skuAllImg"
            @skuImgChange="skuImgChange"
            @changeSkuAllImg="changeSkuAllImg"
          ></FileUpload>
        </el-form-item>
      </el-form>
      <el-form-item
        class="goods-produce"
        label="路线介绍："
        prop="detailPc"
        style="margin-bottom:15px"
      >
        <span style="color:#4A4A4A">电脑端描述</span>
      </el-form-item>
      <div class="title-input-message">
        <el-kindeditor
          class="pcedit"
          id="editor_id"
          width="700px"
          height="300px"
          :content.sync="editorText"
          :afterChange="afterChange()"
          pluginsPath="../../../node_modules/kindeditor/plugins/"
          :loadStyleMode="false"
          :autoHeightMode="false"
          :uploadJson="uploadJson"
          :fileManagerJson="fileManagerJson"
          :agentId="agentId"
          ref="elKindeditor"
          :selectedFile="selectedFile"
          @on-content-change="onContentChange"
          :headers="headers"
          :pasteType="1"
        >
        </el-kindeditor>
      </div>
      <div class="title-input-message">
        <p class="explain first-explain">
          1.支持文字+图片形式；图文介绍应包含路线基础信息描述（包括材质、规格、尺寸、用途、颜色、适用场景等）、服务承诺等相关信息，可上传多张路线属性信息的图文格式图片。
        </p>
        <p class="explain first-explain">
          2.路线介绍文字：字体要求统一字体，文字及图片、图标等不能带有超链接
        </p>
        <p class="explain first-explain">3.图片要求：</p>
        <p class="explain first-explain" style="padding-left:10px">
          电脑端：图片最大宽度不超过750px，长度不限
        </p>
        <!-- <p class="explain first-explain">
          4.路线售后保障（如实际路线不提供此项服务，可不必上传）：需填写具体的路线售后服务内容，包括不限于质保周期、退换货条件等。如：条例中必须包含“我公司郑重承诺在我公司所采购路线均享有终身免费上门服务”，并加盖单位公章，以图片的形式上传
        </p> -->
      </div>
      <!-- <el-form-item label="路线介绍：" style="margin-bottom:15px">
        <span style="color:#4A4A4A">手机端描述</span>
      </el-form-item>
      <div class="title-input-message">
        <el-mobile-editor
          class="medit"
          ref="meditor"
          :transitionData="transitionData"
          :mobileData="mobileData"
          :allFileList="allFileList"
          @reloadImages="reloadImages"
          @transition="transition"
          :agentId="agentId"
          :urlImg="uploadUrl"
          :headers="headers"
        ></el-mobile-editor>
        <el-upload
          v-show="false"
          class="upload-demo"
          ref="uploadAvatar"
          :data="upLoadData"
          :action="uploadUrl"
          :headers="headers"
          :on-success="handlePreview"
          :on-preview="handlePreview"
          :on-remove="handleRemove"
          :before-remove="beforeRemove"
          multiple
          :before-upload="beforeAvatarUpload"
          :on-exceed="handleExceed"
          :file-list="mobileFileList"
        >
          <el-button size="mini" type="primary-font-mini">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">
            只能上传jpg/png文件，且不超过2MB
          </div>
        </el-upload>
      </div>
      <div class="title-input-message">
        <p class="explain first-explain">
          1.支持图片形式；介绍应包含路线基础信息描述（包括材质、规格、尺寸、用途、颜色、适用场景等）、服务承诺等相关信息，可上传多张路线属性信息的图文格式图片。
        </p>
        <p class="explain first-explain">2.图片要求：</p>
        <p class="explain first-explain" style="padding-left:10px">
          手机端：图片最大宽度不超过640px，长度不限
        </p>
        <p class="explain first-explain" style="padding-left:10px">
          图片格式：Jpg、gif、png
        </p>
        <p class="explain first-explain">
          3.路线售后保障（如实际路线不提供此项服务，可不必上传）：需填写具体的路线售后服务内容，包括不限于质保周期、退换货条件等。如：条例中必须包含“我公司郑重承诺在我公司所采购路线均享有终身免费上门服务”，并加盖单位公章，以图片的形式上传
        </p>
      </div> -->
      <!--<el-form-item label="店铺类目：" prop="userName">-->
      <!--<el-select v-model="form.userName" class="input-long" placeholder="请选择" value="">-->
      <!--<el-option label="10" value="10"></el-option>-->
      <!--<el-option label="20" value="20"></el-option>-->
      <!--<el-option label="30" value="30"></el-option>-->
      <!--<el-option label="40" value="40"></el-option>-->
      <!--</el-select>-->
      <!--</el-form-item>-->
    </el-form>
    <select-picture
      ref="selectPCPicture"
      :type="selectPictureType"
      :editorText.sync="editorText"
      reNodeName="selectPCPicture"
    ></select-picture>
    <!-- <upLoadPicture
      ref="UpLoadPicture"
      type="UpLoadPicture"

    /> -->
    <select-picture
      ref="selectPhonePicture"
      :type="selectPictureType"
      @insertMeditorPicturer="handlePreview"
      reNodeName="selectPhonePicture"
    ></select-picture>
  </div>
</template>

<script>
import FileUpload from "./file-upload";
// import upLoadPicture from "./uploadPicture";
import selectPicture from "./pictureManage/selectPicture";
// import {getFileList} from '@/api/goods-publish'
import { Loading } from "ccui";
import Cookies from "js-cookie";
import { isEmpty } from "lodash";
import { addUrlPerFix } from "@/utils";
const baseURL = addUrlPerFix(process.env.VUE_APP_BASE_URL);

export default {
  name: "goods-info",
  data() {
    return {
      dynamicTags: [],
      inputVisible: false,
      inputValue: "",
      selectPictureType: "",
      skuAllImg: {},
      // 批文附件上传
      uploadJson: baseURL + "apis/wlyy/cc/manager/uploadTextEditorFileToOss",
      editorText: "", // 双向同步的变量
      fileManagerJson: [
        {
          createDay: 25,
          createMonth: 4,
          createTime: "2020-04-25 10:40:30",
          createUserId: 10000000001,
          createUserType: 0,
          createWeek: "2020-04-20~2020-04-26",
          createYear: 2020,
          downloadPermission: "",
          downloadUrl:
            "https://ss1.bdstatic.com/70cFvXSh_Q1YnxGkpoWK1HF6hhy/it/u=2908207382,1429820199&fm=26&gp=0.jpg",
          fileCategory: 0,
          fileCenter: 0,
          fileClass: 0,
          fileName: "man.png",
          filePath: "BASA_main/10000000001@100003/2020/4/25/man.png",
          filePreview: 0,
          fileSize: 1265,
          fileState: 0,
          fileType: 2,
          isDelete: 0,
          isSecret: 0,
          orgAlias: "",
          orgId: 100003,
          orgTitle: "",
          ossUrl:
            "https://ss0.bdstatic.com/70cFuHSh_Q1YnxGkpoWK1HF6hhy/it/u=1441048056,993952330&fm=11&gp=0.jpg",
          percentage: 0,
          updateTime: "2020-04-25 10:40:30",
          updateUserId: 10000000001,
          updateUserType: 0,
          uploadId: 10000000121
        },
        {
          createDay: 26,
          createMonth: 4,
          createTime: "2020-04-26 14:39:15",
          createUserId: 10000000001,
          createUserType: 0,
          createWeek: "2020-04-20~2020-04-26",
          createYear: 2020,
          downloadPermission: "",
          downloadUrl:
            "https://ss2.bdstatic.com/70cFvnSh_Q1YnxGkpoWK1HF6hhy/it/u=2405042072,1084145418&fm=11&gp=0.jpg",
          fileCategory: 0,
          fileCenter: 0,
          fileClass: 0,
          fileName: "women.png",
          filePath: "BASA_main/10000000001@100003/2020/4/26/women.png",
          filePreview: 0,
          fileSize: 1335,
          fileState: 0,
          fileType: 2,
          isDelete: 0,
          isSecret: 0,
          orgAlias: "",
          orgId: 100003,
          orgTitle: "",
          ossUrl:
            "http://cccc-dev.oss-cn-beijing.aliyuncs.com/BASA_main/10000000001%40100003/2020/4/26/women.png?Expires=1903243155&OSSAccessKeyId=LTAI4G9duV64p4L6NuPAnB6G&Signature=loZV8QOcvW%2BQW5YnAkFpx8tvz3g%3D",
          percentage: 0,
          updateTime: "2020-04-26 14:39:15",
          updateUserId: 10000000001,
          updateUserType: 0,
          uploadId: 10000000141
        },
        {
          createDay: 23,
          createMonth: 4,
          createTime: "2020-04-23 18:28:16",
          createUserId: 10000000001,
          createUserType: 0,
          createWeek: "2020-04-20~2020-04-26",
          createYear: 2020,
          downloadPermission: "",
          downloadUrl:
            "https://ss3.bdstatic.com/70cFv8Sh_Q1YnxGkpoWK1HF6hhy/it/u=2908283040,246645897&fm=26&gp=0.jpg",
          fileCategory: 0,
          fileCenter: 0,
          fileClass: 0,
          fileName: "采购管理.png",
          filePath: "BASA_main/10000000001@100003/2020/4/23/采购管理.png",
          filePreview: 0,
          fileSize: 311,
          fileState: 0,
          fileType: 2,
          isDelete: 0,
          isSecret: 0,
          orgAlias: "",
          orgId: 100003,
          orgTitle: "",
          ossUrl:
            "http://cccc-dev.oss-cn-beijing.aliyuncs.com/BASA_main/10000000001%40100003/2020/4/23/%E9%87%87%E8%B4%AD%E7%AE%A1%E7%90%86.png?Expires=1902997697&OSSAccessKeyId=LTAI4G9duV64p4L6NuPAnB6G&Signature=w7KyO5SaBAVV%2FqKe49JQlDUl%2FRA%3D",
          percentage: 0,
          updateTime: "2020-04-23 18:28:16",
          updateUserId: 10000000001,
          updateUserType: 0,
          uploadId: 10000000231
        }
      ],
      editorTextCopy: "",
      uploadUrl: baseURL + "apis/wlyy/cc/manager/uploadTextEditorFileToOss",
      transitionData: [],
      allFileList: [],
      mobileData: [],
      picturePath: "../../.././examples/assets/images/file-icon/",
      importFileUrl: baseURL + "apis/wlyy/cc/manager/uploadFileToOss", // 上传地址
      headers: {
        Authorization: Cookies.get("access_token") || ""
      },
      // importFileUrl: 'http://dev01-emoma.iccec.cn/apis/emoma/file/uploadFileToOss', // 上传地址
      upLoadData: {
        agentId: window.getArgs("a")
      },
      fileList: [],
      mobileFileList: [],
      reshows: [], //回显图片
      skuPicIds: [],
      reuseImgList: [],
      reuseNeed: "",
      fileList2: [],
      fileListData: [],
      form: {
        spuTitle: "",
        spuPromo: "",
        mainImg: "",
        skuKeyWords: "",
        detailPc: "",
        detailPhone: ""
      },
      rules: {
        spuTitle: [
          { required: true, message: "请输入路线标题", trigger: "blur" },
          { required: true, message: "请输入路线标题", trigger: "change" }
        ],
        spuPromo: [
          { required: true, message: "请输入路线标题", trigger: "blur" }
        ],
        mainImg: [
          {
            required: true,
            message: "请上传至少1张最多8张图片",
            trigger: "select"
          }
        ],
        detailPc: [
          { required: true, message: "请编辑PC端路线描述", trigger: "change" }
        ],
        detailPhone: [
          { required: true, message: "请编辑移动端路线描述", trigger: "blur" }
        ]
      },
      skuForm: {},
      skuRules: {},
      imageUrl: "",
      // agentId:'9F6FD19CCFA4A74EF59553278604963F14E94B48A44D13C4E3758FC17D927718',
      agentId: window.getArgs("a"),
      phoneAllImg: {}
    };
  },
  props: ["uploadForm", "goodsTitle", "goodsInfo", "skuKeyWords"],
  components: {
    FileUpload,
    // upLoadPicture
    selectPicture
  },
  watch: {
    skuKeyWords(value) {
      if (value) this.dynamicTags = value.split(",");
    },
    goodsTitle() {
      this.form.spuTitle = this.goodsTitle;
    },
    goodsInfo: {
      immediate: true,
      deep: true,
      handler() {
        console.log(this.goodsInfo, "goodsInfo1111111111");
        if (isEmpty(this.goodsInfo)) return;
        console.log(this.goodsInfo, "goodsInfo2222222222");
        this.fileList = [];
        this.form.spuTitle = this.goodsInfo.spuTitle;
        this.form.spuPromo = this.goodsInfo.spuPromo;
        let that = this;
        let reshows = [];
        let skuPicIds = [];
        let skuAllImg = {};

        this.goodsInfo.pictureRspBOS.forEach((item, index) => {
          if (!item.skuId) {
            //主图，sku为0
            item.pictures.forEach(obj => {
              skuPicIds.push(obj.skuPicId);
              that.fileList.push({
                url: obj.url,
                percentage: 100,
                name: obj.url,
                response: {
                  data: [
                    {
                      downloadUrl: obj.url,
                      uploadId: obj.uploadId,
                      skuPicId: obj.skuPicId
                    }
                  ]
                }
              });
            });
          } else {
            //sku图
            let reshow = [];
            item.pictures.forEach(obj => {
              skuPicIds.push(obj.skuPicId);
              reshow.push({
                url: obj.url,
                percentage: 100,
                name: obj.url,
                attr: "",
                response: {
                  data: [
                    {
                      downloadUrl: obj.url,
                      uploadId: obj.uploadId,
                      skuPicId: obj.skuPicId
                    }
                  ]
                }
              });
            });
            skuAllImg[item.propNameJoin] = JSON.parse(JSON.stringify(reshow));
            reshows.push(reshow);
          }
        });
        this.skuAllImg = skuAllImg;
        this.reshows = reshows;
        this.skuPicIds = skuPicIds;
        this.editorText = this.goodsInfo.detailPc;
        // this.$refs.elKindeditor.setContent(this.goodsInfo.detailPc);
        // this.mobileData = JSON.parse(this.goodsInfo.detailPhone);
        console.log(this.fileList, "11111111111111111");
      }
    },
    fileList: {
      deep: true,
      handler() {
        this.form.mainImg =
          this.fileList.length && this.fileList.length < 9 ? "1" : "";
        console.log("this.fileList.length", this.fileList.length);
        this.$refs.form.validateField("mainImg");
      }
    },
    uploadForm() {
      let skuForm = {};
      let skuRules = {};
      let that = this;
      // for(var key in this.skuAllImg){
      //   if(this.uploadForm.indexOf(key)!==-1){
      //     delete this.skuAllImg[key]
      //   }
      // }
      // console.log(this.skuAllImg)
      this.uploadForm.forEach((item, index) => {
        if (that.skuAllImg[item]) {
          skuForm["skuImgList" + index] = that.skuAllImg[item];
        } else {
          skuForm["skuImgList" + index] = "";
        }
        skuRules["skuImgList" + index] = [];
        skuRules["skuImgList" + index].push({
          required: true,
          message: "请上传至少1张最多8张图片",
          trigger: "blur"
        });
      });
      this.skuForm = skuForm;
      this.skuRules = skuRules;
    }
  },
  created() {},
  mounted() {
    let _this = this;
    console.log(this.$refs.elKindeditor.items);
    this.$refs.elKindeditor.items.splice(37, 1, "remote_image");
    window.KindEditor.lang({
      remote_image: "批量选择图片"
    });
    window.KindEditor.plugin("remote_image", function(id) {
      let editor = this;
      console.log("this", editor);
      let name = "remote_image";
      editor.clickToolbar(name, () => {
        _this.selectPictureType = "PCSelect";
        _this.$refs.selectPCPicture.open();
      });
    });
  },
  methods: {
    setData(val){
      console.log(val,"基本信息回显");
      this.dynamicTags = val.skuKeyWords? val.skuKeyWords.split(",") : [];
      this.form = Object.assign(this.form, val);
    },
    handleClose(tag) {
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
    },

    showInput() {
      console.log(this.inputValue, "inputValue");
      this.inputVisible = true;
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },

    handleInputConfirm() {
      let inputValue = this.inputValue;
      if (inputValue) {
        this.dynamicTags.push(inputValue);
      }
      console.log(this.dynamicTags, " this.dynamicTags");
      this.inputVisible = false;
      this.inputValue = "";
    },
    showSelectPicDialog(e) {
      // this.$refs.UpLoadPicture.open();
      this.$refs.selectPicture.open(e);
    },
    skuImgChange(flieList, index) {
      console.log("skuImgChange", flieList);
      if (flieList && flieList.length) {
        this.skuForm["skuImgList" + index] = flieList;
      } else {
        this.skuForm["skuImgList" + index] = "";
      }
      this.$refs.skuImgList.validate();
    },
    changeSkuAllImg(fileList, attr) {
      this.skuAllImg[attr] = fileList;
      console.log(this.skuAllImg);
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
      this.phoneAllImg[file.data[0]] = file.data[1];
      // this.$refs.meditor.insertImg(file.data[0]);
    },
    beforeRemove(file, fileList) {
      // return this.$confirm(`确定移除 ${ file.name }？`);
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 3 个文件，本次选择了 ${
          files.length
        } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      );
    },
    beforeAvatarUpload(file) {
      let isUpload = true;
      let fileType = ["jpg", "jpeg", "png", "gif", "bmp"];
      let fileTypeLen = file.name.split(".");
      let isFile = fileType.includes(
        fileTypeLen[fileTypeLen.length - 1].toLowerCase()
      );
      // let isFileIdx = fileType.indexOf(
      //   fileTypeLen[fileTypeLen.length - 1].toLowerCase()
      // )
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (isFile) {
        if (!isLt5M) {
          this.$message({
            type: "error",
            ccuiCustom: true,
            showClose: true,
            message: "上传文件大小不能超过 5MB!",
            offset: document.documentElement.clientHeight / 2 - 21
          });
          isUpload = false;
        } else {
          if (file.name.slice(0, file.name.lastIndexOf(".")).length > 50) {
            this.$message({
              type: "error",
              ccuiCustom: true,
              showClose: true,
              message: "上传文件名称长度不能超过50个字符!",
              offset: document.documentElement.clientHeight / 2 - 21
            });
            isUpload = false;
          }
        }
      } else {
        this.$message({
          type: "error",
          ccuiCustom: true,
          showClose: true,
          message: `上传文件支持格式：.jpg .png .jpeg .gif每个不超过5M`,
          offset: document.documentElement.clientHeight / 2 - 21
        });
      }
      return isFile && isUpload;
    },

    // 附件信息上传tu
    changeFile(file, fileList) {
      console.log("fileList:", fileList);
      this.fileList = fileList;
      for (let i = 0; i < fileList.length; i++) {
        if (
          ["doc", "docx"].indexOf(
            fileList[i].name
              .split(".")
              .pop()
              .toLowerCase()
          ) !== -1
        ) {
          fileList[i].url =
            "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAE8AAABPCAYAAACqNJiGAAAJHElEQVR4Xu2ce3RTRR7Hv0mapM2jadImLWyhIHaPFu2hlYe8KQVdWxChFMG6CFJYj+su9qyrnOOKehDOqvXB0ZUtbXkIFEFe9dFFdBErbFug5VFRVCrQLdD0lfSRtGnTZM8kJDc3CSv2NjdddubPe/ObO/O535nfzC/zu4Jrhs7jgGAMaLl5AnZ0CYT2dME1Q5f95q3oL10E7EAOhddHPVB4fQRHzCg8Co8DAQ6mVHkUHgcCHEyp8ig8DgQ4mFLlUXgcCHAwpcqj8DgQ4GBKlUfhcSDAwZQqj8LjQICDKS/Kq7zWjX/VWVjNHKkVY/qwUL9Nr2vrxf7vzT73fpesgEQk8Guz+1sz9KZe1r3FiXKopEIOeP67KS/wCLhHi1tYLUmKFmPv/Ci/rdt5zoznj7T63CvOjMLdOrHP9V6bHaMK9DD1MAFxdagQJx7XQSjwD7s/iPICr7vXjqQCPTqtTOckIuBMdgykIb6d+8uRVhSd81Xe2mkqLBop8+n3t009mLWriXV9dnwo1t+n7g9GN6yDF3jk6cs+acGXl9lDd/e8SIweJPFp3EMfNuFsQ4/PdQKOAPQu26vNWF3KVupr01WYf6cv6P6kyRu8rWdNePnrNlbbV41XYkWygnXNarPjro16ELV6FzJkydD1LjmfG1H8QyfrctkSHaLlov5k5VMXb/AuGq1I3dHIasDM4VLkpWlY18439SDNYwjKxQL3XEaGevXyGIi9nMaU9xtQ1844izsiQ1CyUBtQcKRy3uCRh03Z1gDiSV0lMoxM6tGsTu75zoxnDzND8JGRMtb89/GCKBBP7SrEw47f0sCqY0WSHKsmhN9a8Pw5gsNZWgyLCHF39OXSVmytdjqLGLkQa6apsPxTg/v+umkqLPRwGiUXOvHUZ0YWqG1zNJgYK7214B36qQtP/IMBQXr3eqoKGXcwE3vmvmaQdSEpM4ZLHQ5i3GZGWUSJr3g4jVeOtmHTGZMbVFiIAFXZ0ZDeYD3Yn0R5HbYd3TYkF+phtTFdWJQgw9oUpwe12e1IzNfDfH299vRYBf44RokJW/SoNzmNEnViHPBwGnP3NOGMnvHMKXFSFM5iz6P9CcyzLl7hkQc/vL8ZJ646lUXKrzUhOLjIObnXGKyYWcQ4lcJ0NVKGheKJkhYcuuhc5jicxooYiIUCdFkJ7HrWy3hxcjgeS5QHiherXt7h/e1kO96o6HA3giyRT2VHI1wqdCw3yLLDVSqW6qCVifDuyQ68WdHuvv7JgigkaMWouNKNRQeaWR36IkuL2zzm0EBS5B1edUM35nzI7vDmWRpMjZNi3bE2FJx2zl/RciHKljg9cWmtBUs+ZrZ3f01RYUGCDO9VdiC3nIEaqxShdLEukLyCqzybHRi7SY+WLmbi+8NoBXLGKZF1oBllV5xDOnWYFPnpzrnL0GnDPZv07oZn3SXDmqkqZH/agsOXmF3LjXYggaLJu/JIR54+ZMRHPzI7ggmxEmx7MBJJhfVoszh3Fi5n4er41G0N+Pf1NeIoElTIiHIANXq8hA0PqHH/bf4jNYEAGBR4+8534pl/MnObTCwAWfx67kAK0tWskNVTBw0oqelyMCDLkP2ZkUj7gAkGkPgCWaIoJIELQXm/gKDAazT3stZupFFP3iPHe5XMeq18iQ46j71pXlUHXi1j5rfHEmXYepaJvIwZJMauef5DXIFQHakzKPDIg9N3NeK7Jqu7X5pQoXse9HQWrh94xwQVYgE6POJ3fxqnwO9HKwPFyW+9QYP3alkb8qoYpXm2ztNZuK63d9swKl9P3rbfUpwZibt1vuGtQNIMGryyOguyvKLLro6uHKPAyrG+Kkrd0YCLRnaondgQ1R5/PBrCwAWNB5bySLyObNVcWzHP1uWnq5Hq5/8Nf3E7YvdgfBjevi8ikCIbWPBIa7zXaa4WejsL13USACCBAO+Sm6rCPI/gAl8UgzZsSQffrzbhpVI2DJ1MiPKl7BifCwbZE5O9sXe5EexAQwwqvEtGKxZ4wZgYK8FbM/3/cUOGeMr2BpbTGBERgp1zIwPNaeAN26D0uB8fGlTl9WM/glIVhccBO4VH4XEgwMGUKo/C40CAgylVHoXHgQAHU6o8Co8DAQ6mVHkUHgcCHEyp8ig8DgQ4mFLlUXgcCHAwdSgv/7jB3u37pxSHav8/TEOE9mcFg3Iv2Y30i0i/+I3HyEWrKbxfjM1pQOH1ERyFxwEchfe/Bk8rE+L1VCbBhGQqVjf0YPMZMyzXPT45tE3Oq6THS6GUCBynqd6oMOFUPXPqffQgMf58rwK3a0So77BhxzedKDrHTqHiyOZnzXmf8+JUIpzK1uLHFiu+b7ZCJxdi7GCJI/fi/p0tIMdut8+JQNrtofisxoLatl7MjpeCpIDO2t2Cyms9SIoRo+RhDYwWG0ouWBwn6icOkeDF0na8c8L/yaufJdGHHwQNXm55B9Ydc56Kf268As9NUODRYgNaOm0oWRiJjVUmrPrSeZjxV0qSZqVFWV03MvYaUPSQGjOGS3Dv5ib8dP3U1N4MNQYrRRi/hZ062gcmN20yIODFa0SoWKrF2qPtDuW9MFmJ6dubcdojOWXXPDUmD5Fg8Ho9ap7U4YLB6lBqMMuAgDc0XITTy7VYf9zkyALKGadAckEjLrUy2568NBUy7wyD7s161K2Mxte13cjcx07F4hvkgID3mxFSx1B85gtyYsqO3BkqPHLAgIM1TJpA6W8jESUTIiGvEVXLokCy35MLmtyHfhYmhCFeE4I1R5lzy4GGGTR4JFllQ6UZxIG8Nj0cseEiJBc2OoZt1TItalt7sfgjgyOPlqSAvjRFiXdPmrD6q3a8MInkbSiw7lg7/l5pRmI0OSmlxomrPZi/lz81Bg2epypILkXO520o/sGZKkC864YHIkBSDOx2OFR25DL5yIPRcZKUZDZ+MFeNyUOZM8jkuNrcPQZc9hjqt5zyyBrO8wsVJPmOLFu8ozpRYUJMjZM41nnnm60ov8L+5gA5fjxpiAQj1CJcbbfhq1qLe50YaGiu+nlXHl8d4+M5FB4HyhQeV3hD36q1Npp6A/sdDQ6NHKimwyPEzwtmF+kzvtFbEgZqIwdiu8LEwt5JceEb/wPl05FuSv4X0gAAAABJRU5ErkJggg==";
        } else if (
          ["pdf", "PDF"].indexOf(
            fileList[i].name
              .split(".")
              .pop()
              .toLowerCase()
          ) !== -1
        ) {
          fileList[i].url =
            "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABQCAYAAACOEfKtAAAEyElEQVR4Xu3cbWwTdRwH8O//2mtp17FuY8/MZZgoFIRt6iZPUROjMSiavUCXuTjjw15ogm94JRohOl6M6AA3YSM6FDEkxCWCwxANumjMYpy+MWjAh2kY7Ta4jrGts9eeac0u7Uog1x94d8mv77b+v5f/75PvXZfLrkJRlCEA9eCXIQFN04JOp/MOoSiKZijJi3UBIcRdDEgoBAMS8BJRBmRAogAxzg1kQKIAMc4NZECiADHODWRAogAxzg1kQKIAMc4NZECiADFuegMnt22FFotdfwwBiEVeCF8OHJVVkFcEIK+pg3A6r5+9iStMBxxbXweoalYjSoVL4NnSBO9TrRBOOatjUEO2Bpwf3rliJfz7eiDl5lI9DOctByj8fgg5s01aVIU2GQa0q988dzWsg3/vfsMA1IDlAPN7DkFeU3vVuTRVRXwshMjnn2Hm6EfQwkraurzObrjXbqCaGMrbCjB1MvX3c1CeaYYWmdV/vWjTZix+7Q1DANTFtgVMDD61Zzdmj3ygGzgqb0HhsRNUE0N5WwNGBo7j8o5X9IGFNwdFp78zBEBdbGvAucHTSPwdqb9kGcXf/EA1MZS3NeD0h+9j+p239YGlomIsOfGFIQDqYtsCJj6RledaoJ75WTdwNayFf+8BqomhvC0B42EFV7o6Efm0P21Y38vb4G1qMQRAXWw5QE/jFkhl5ZlzRaOIXxxHLBTEP98PAXNzaWuk/AIUfjIA4fVSTQzlLQdoaPfzi2UZ/re64Kq/J6s4JWR7QEdFJXJf3QlX7Z0Uh6yztgSUSssgB1bB/cCDcG+8H8LlyhqAGrQc4OI3O5L3+jJfInl9Ezk+U8EW7stygNe6mUBty83IMyBRlQEZkChAjHMDGZAoQIxzAxmQKECMcwPtDkjcv+lx0xtougBxAwzIgEQBYpwbyIBEAWKcG8iARAFinBvIgEQBYpwbyIBEAWKcG8iARAFinBt4IwBH3+vl743JElL48+4Tv95WyYBZAno3bW5kwCzxEjEGJOAxIBGPARnwBggQD2HaNdBRXAK5pDS5fU3TEJsYhxq8kPw59b14JILoX39CS/mfaLn6Vjh8vrTR1bEQ1FCQyGE8bhpgwYtbUdD2EmJjIUCS4CgqQuSnYZx/vhX5z76gvyd8Pjjy/Jg8dhTj7Tugzc5g6aGP4Q6sQnxyUp9YOdyHcN9B4wLEhKmAORvuxd9Njf+1Lr8AVQNfYmL3LjhLy5D6nly9DOX7ejD97SAmdu1MAs7+OIyLnR3E8elxywAmWrjs6yFc6n03+eB0KmBiTN/Dj6Dk9Xb81rCaARMgiVM474lmTB3vB4QE9+3L4am7GyOPPYTcRx/PAHQHVqKq/yTO1gVQ0d0LT8O6tIevz7e1YmbwK3qlDB7B1AbqgHEN6sQ4rpw6CfXCaBJ3YQO96zeivPsgztUsx9K+I5j75QwuHejSx41NXQaiUYPj05ebCrgQaX6cDECHA2V79ie/CmC0rZVP4flT+FqA/idbMHVqAJIvF56a2sSXlSY/oaMjfzAg/cSxzhFMO4WtQ0DbCQPS/Ph2FtGPARmQKkDMJ6+BZ+tXT8fDyv/7qDdx41aIC6dT8zY/XSeC27dXR6eVGitsyk57kDzekYr2juF/AWVxw9hRb5l2AAAAAElFTkSuQmCC";
        } else if (
          ["xls", "xlsx"].indexOf(
            fileList[i].name
              .split(".")
              .pop()
              .toLowerCase()
          ) !== -1
        ) {
          fileList[i].url =
            "data:image/png;base64,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";
        } else if (
          ["txt"].indexOf(
            fileList[i].name
              .split(".")
              .pop()
              .toLowerCase()
          ) !== -1
        ) {
          fileList[i].url =
            "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABQCAYAAACOEfKtAAAAAXNSR0IArs4c6QAAAy5JREFUeAHt3N9LU2EcBvDv1nFz2uxQw/TG1UXWEGa1UdTCH9FFqyDpJkLpPuhfCPobgvoTIrrpl9GFOfpBFxUzNJckahhlSNhWoWa6rXNONBge58azji/4DLw47/s+h53PnnPQM46uTCYzkM/nTwhflQpM67oedqXT6XylSa7/K+ByuaJuYmACBMT8hIAEBAXAOBtIQFAAjLOBBAQFwDgbSEBQAIyzgQQEBcA4G0hAUACMa2C+4vjE5CcZTU1WnCsVCAab5UB7a6kl/23OccBM5qdMfZip6gHV1/uqur9KdsZrYCVaNmsdb2BNjSZbSzTGvD0+P79Y9FZ9Pq9sca/9Wdd6PUXrndxQ7pb+ykpWrl2/XWRwsTcugYBeNKbCBm/pV+FTWPu8qMLON8MuCAh+ygQkICgAxtlAAoICYJwNJCAoAMbZQAKCAmCcDSQgKADG2UACggJgnA0kICgAxtlAAoICYJwNJCAoAMaV+1YOPB5H4/xWrgrcvAaCiAQkICgAxtlAAoICYJwNJCAoAMbZQAKCAmCcDSQgKADG2UACggJgXBsZnQB3sXnj/oY6XXs8+HrzCoBHHo2EmngNBBEJSEBQAIyzgQQEBcA4GwgCOv60pvFVoPReiNu+7eTQmEQOhmRg8KXMzs5Zaw5F26SlpUmSyTGJxfavyuVyebl569GqcacGHG+g8d8y5a3xy7v54zYeYfX76wvb0x+/iPm05rme49bczsbtEj8Zk/fj0/It86OwrtEYX1r6bW2Ppjb2DwHHG2g2Y3hk3CpIc3NAdmS3FbbNwfv9T+XypfPS1RmRvXuCkno3ZUGZc/9yR4+0y+eZr4Vtc26jXo43cL0DXVj4JfcePJGujqjUGQ9m9z98tl5kQ+eVAzQ1stmchZLL5cQ85VV+KQfoq/VKz9luef7ijXGdW5ZT8WMq+6n3L0DPnO6QReM0TiReyZ27CQmHWyW0b7eyiK4rV2+ofY4oSydi3I3pU+4UVtjL9q0R0Jal/EEClm9lu5KAtizlDxKwfCvblW5d9y/bznCwpECNpuX1hoYh7XC0bddc+nt3ydWcXCVQ6/EMd3ZGxv4AbrGvt5HM8f0AAAAASUVORK5CYII=";
        }
      }
    },
    // 删除附件信息
    onFileDelete(file) {
      console.log(file);
      this.fileList.splice(file, 1);
      console.log("fileList:", this.fileList);
    },
    // 附件信息成功的时触发
    handleSuccess(response, file, fileList) {
      // file.id = response.data.fileKey
      // file.percentage = 100
      console.log("1response", response);
      console.log("2file", file);
      console.log("3fileList", fileList);
      for (let i = 0; i < fileList.length; i++) {
        if (
          ["doc", "docx"].indexOf(
            fileList[i].name
              .split(".")
              .pop()
              .toLowerCase()
          ) !== -1
        ) {
          fileList[i].url =
            "data:image/png;base64,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";
        } else if (
          ["pdf", "PDF"].indexOf(
            fileList[i].name
              .split(".")
              .pop()
              .toLowerCase()
          ) !== -1
        ) {
          fileList[i].url =
            "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABQCAYAAACOEfKtAAAEyElEQVR4Xu3cbWwTdRwH8O//2mtp17FuY8/MZZgoFIRt6iZPUROjMSiavUCXuTjjw15ogm94JRohOl6M6AA3YSM6FDEkxCWCwxANumjMYpy+MWjAh2kY7Ta4jrGts9eeac0u7Uog1x94d8mv77b+v5f/75PvXZfLrkJRlCEA9eCXIQFN04JOp/MOoSiKZijJi3UBIcRdDEgoBAMS8BJRBmRAogAxzg1kQKIAMc4NZECiADHODWRAogAxzg1kQKIAMc4NZECiADFuegMnt22FFotdfwwBiEVeCF8OHJVVkFcEIK+pg3A6r5+9iStMBxxbXweoalYjSoVL4NnSBO9TrRBOOatjUEO2Bpwf3rliJfz7eiDl5lI9DOctByj8fgg5s01aVIU2GQa0q988dzWsg3/vfsMA1IDlAPN7DkFeU3vVuTRVRXwshMjnn2Hm6EfQwkraurzObrjXbqCaGMrbCjB1MvX3c1CeaYYWmdV/vWjTZix+7Q1DANTFtgVMDD61Zzdmj3ygGzgqb0HhsRNUE0N5WwNGBo7j8o5X9IGFNwdFp78zBEBdbGvAucHTSPwdqb9kGcXf/EA1MZS3NeD0h+9j+p239YGlomIsOfGFIQDqYtsCJj6RledaoJ75WTdwNayFf+8BqomhvC0B42EFV7o6Efm0P21Y38vb4G1qMQRAXWw5QE/jFkhl5ZlzRaOIXxxHLBTEP98PAXNzaWuk/AIUfjIA4fVSTQzlLQdoaPfzi2UZ/re64Kq/J6s4JWR7QEdFJXJf3QlX7Z0Uh6yztgSUSssgB1bB/cCDcG+8H8LlyhqAGrQc4OI3O5L3+jJfInl9Ezk+U8EW7stygNe6mUBty83IMyBRlQEZkChAjHMDGZAoQIxzAxmQKECMcwPtDkjcv+lx0xtougBxAwzIgEQBYpwbyIBEAWKcG8iARAFinBvIgEQBYpwbyIBEAWKcG8iARAFinBt4IwBH3+vl743JElL48+4Tv95WyYBZAno3bW5kwCzxEjEGJOAxIBGPARnwBggQD2HaNdBRXAK5pDS5fU3TEJsYhxq8kPw59b14JILoX39CS/mfaLn6Vjh8vrTR1bEQ1FCQyGE8bhpgwYtbUdD2EmJjIUCS4CgqQuSnYZx/vhX5z76gvyd8Pjjy/Jg8dhTj7Tugzc5g6aGP4Q6sQnxyUp9YOdyHcN9B4wLEhKmAORvuxd9Njf+1Lr8AVQNfYmL3LjhLy5D6nly9DOX7ejD97SAmdu1MAs7+OIyLnR3E8elxywAmWrjs6yFc6n03+eB0KmBiTN/Dj6Dk9Xb81rCaARMgiVM474lmTB3vB4QE9+3L4am7GyOPPYTcRx/PAHQHVqKq/yTO1gVQ0d0LT8O6tIevz7e1YmbwK3qlDB7B1AbqgHEN6sQ4rpw6CfXCaBJ3YQO96zeivPsgztUsx9K+I5j75QwuHejSx41NXQaiUYPj05ebCrgQaX6cDECHA2V79ie/CmC0rZVP4flT+FqA/idbMHVqAJIvF56a2sSXlSY/oaMjfzAg/cSxzhFMO4WtQ0DbCQPS/Ph2FtGPARmQKkDMJ6+BZ+tXT8fDyv/7qDdx41aIC6dT8zY/XSeC27dXR6eVGitsyk57kDzekYr2juF/AWVxw9hRb5l2AAAAAElFTkSuQmCC";
        } else if (
          ["xls", "xlsx"].indexOf(
            fileList[i].name
              .split(".")
              .pop()
              .toLowerCase()
          ) !== -1
        ) {
          fileList[i].url =
            "data:image/png;base64,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";
        } else if (
          ["txt"].indexOf(
            fileList[i].name
              .split(".")
              .pop()
              .toLowerCase()
          ) !== -1
        ) {
          fileList[i].url =
            "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABQCAYAAACOEfKtAAAAAXNSR0IArs4c6QAAAy5JREFUeAHt3N9LU2EcBvDv1nFz2uxQw/TG1UXWEGa1UdTCH9FFqyDpJkLpPuhfCPobgvoTIrrpl9GFOfpBFxUzNJckahhlSNhWoWa6rXNONBge58azji/4DLw47/s+h53PnnPQM46uTCYzkM/nTwhflQpM67oedqXT6XylSa7/K+ByuaJuYmACBMT8hIAEBAXAOBtIQFAAjLOBBAQFwDgbSEBQAIyzgQQEBcA4G0hAUACMa2C+4vjE5CcZTU1WnCsVCAab5UB7a6kl/23OccBM5qdMfZip6gHV1/uqur9KdsZrYCVaNmsdb2BNjSZbSzTGvD0+P79Y9FZ9Pq9sca/9Wdd6PUXrndxQ7pb+ykpWrl2/XWRwsTcugYBeNKbCBm/pV+FTWPu8qMLON8MuCAh+ygQkICgAxtlAAoICYJwNJCAoAMbZQAKCAmCcDSQgKADG2UACggJgnA0kICgAxtlAAoICYJwNJCAoAMaV+1YOPB5H4/xWrgrcvAaCiAQkICgAxtlAAoICYJwNJCAoAMbZQAKCAmCcDSQgKADG2UACggJgXBsZnQB3sXnj/oY6XXs8+HrzCoBHHo2EmngNBBEJSEBQAIyzgQQEBcA4GwgCOv60pvFVoPReiNu+7eTQmEQOhmRg8KXMzs5Zaw5F26SlpUmSyTGJxfavyuVyebl569GqcacGHG+g8d8y5a3xy7v54zYeYfX76wvb0x+/iPm05rme49bczsbtEj8Zk/fj0/It86OwrtEYX1r6bW2Ppjb2DwHHG2g2Y3hk3CpIc3NAdmS3FbbNwfv9T+XypfPS1RmRvXuCkno3ZUGZc/9yR4+0y+eZr4Vtc26jXo43cL0DXVj4JfcePJGujqjUGQ9m9z98tl5kQ+eVAzQ1stmchZLL5cQ85VV+KQfoq/VKz9luef7ijXGdW5ZT8WMq+6n3L0DPnO6QReM0TiReyZ27CQmHWyW0b7eyiK4rV2+ofY4oSydi3I3pU+4UVtjL9q0R0Jal/EEClm9lu5KAtizlDxKwfCvblW5d9y/bznCwpECNpuX1hoYh7XC0bddc+nt3ydWcXCVQ6/EMd3ZGxv4AbrGvt5HM8f0AAAAASUVORK5CYII=";
        } else {
          fileList[i].url = fileList[i].response.data[0].downloadUrl;
        }
      }
    },
    // 点击已上传附件信息的时触发
    handlePictureCardPreview(file, fileList) {
      console.log("aaa", file);
      console.log("bbb", fileList);
    },
    reloadImages() {
      this.selectPictureType = "meditorSelect";
      this.$refs.selectPhonePicture.open();
      console.log("aaaa");
      // this.$refs.uploadAvatar.$refs['upload-inner'].handleClick();
      // this.getFileList();
    },
    selectedFile($event) {
      const file = $event.target.files[0];
      // 把图片上传到后端服务器 拿到url  uploadImage 是自己后端上传图片的接口
      // 调用appendHtml方法把图片追加到富文本
      // const url= await  uploadImage (file)
      console.log(file, $event, "ccccccccccccccccccccccc");
    },
    // 富文本
    onContentChange(val, empty) {
      this.form.detailPc = val;
      this.$refs.form.validateField("detailPc");
      this.editorTextCopy = val;
      console.log("val", val);
    },
    afterChange() {
      console.log("change");
    },
    getJSON() {
      console.log(this.$refs.elKindeditor);
      let getDomJson = this.$refs.elKindeditor.getChildrenJSON(
        window.KindEditor("#editor_id").text()
      );
      this.transitionData = getDomJson;
      console.log("getDomJson", getDomJson);
    },
    transition() {
      this.getJSON();
    },
    // getFileList() {
    //   getFileList({
    //     fileType: "1,2,3",
    //     agentId:this.agentId,
    //     isShowLoading: true
    //   }).then(res => {
    //     this.allFileList = res.data.data;

    //   });
    // },
    reuseImg() {
      if (!this.fileList.length) {
        return;
      }
      let loadingInstance = Loading.service({
        lock: true,
        text: "处理中，请稍后",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.2)",
        customClass: "ccui-custom-loading"
      });
      setTimeout(() => {
        this.reuseNeed = "all";
        this.reuseImgList = JSON.parse(JSON.stringify(this.fileList));
        this.uploadForm.forEach((item, index) => {
          this.skuImgChange(this.reuseImgList, index);
        });
        loadingInstance.close();
      }, 1500);
    },
    reuseImgCell(index) {
      this.reuseNeed = index;
      this.reuseImgList = JSON.parse(JSON.stringify(this.fileList));
      this.skuImgChange(this.reuseImgList, index);
    },
    submitValid() {
      let detailPc = this.$refs.elKindeditor.getChildrenJSON(
        window.KindEditor("#editor_id").text()
      );
      if (!detailPc.legth) {
        this.form.detailPc = detailPc;
      }
      // this.form.detailPhone = this.$refs.meditor.curData;
      console.log(
        this.$refs.elKindeditor.getChildrenJSON(
          window.KindEditor("#editor_id").text()
        )
      );
      this.$refs["form"].validate();
      this.$refs["skuImgList"].validate();
    }
  }
};
</script>

<style lang="scss" scoped>
/deep/.ke-icon-remote_image {
  background-image: url(data:image/png;base64,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);
  background-position: 0px -496px;
  width: 16px;
  height: 16px;
}

/deep/ .goods-produce {
  .el-form-item__error {
    top: 85%;
  }
}
/deep/ .el-form-item {
  &.upload-list {
    label {
      padding-right: 8px;
    }
  }
}
/deep/ .el-file-upload {
  .file {
    .uploaData {
      margin-bottom: 0;
    }
  }
}
/deep/ .el-form-item {
  margin-bottom: 20px;
}
.title-input-message {
  font-size: 13px;
  margin-bottom: 20px;
  margin-left: 200px;
}
/deep/ .pcedit {
  .ke-container {
    width: 960px !important;
  }
}
.medit {
  width: 960px;
  background: rgba(0, 0, 0, 0.5);
}
.el-button.el-button--default-mini {
  background-color: #fff;
  color: #4a4a4a;
  border-color: #cccccc;
}
/deep/ .el-file-upload {
  margin: 10px 0;
  margin-bottom: 0;
}
/deep/ .el-file-upload .file {
  &:after {
    content: "";
    display: table;
    clear: both;
  }
  .file-list {
    li {
      margin-bottom: 0;
      border: none;
    }
  }
}
/deep/ .el-upload.el-upload--picture-card {
  background: url("../../../../assets/images/upload.png");
  border: 0;
  background-size: 100% 100%;
  .el-icon-plus {
    display: none;
  }
}
.explain {
  line-height: 1.5;
  color: #9b9b9b;
  &.first-explain {
    /*margin-top:8px*/
    max-width: 960px;
    /*white-space:pre;*/
  }
}
.el-file-upload {
  position: relative;
}
.el-upload__tip {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 80px;
  text-align: center;
  background: #9b9b9b;
  color: #fff;
  height: 16px;
  line-height: 16px;
  font-size: 12px;
  margin-left: 0px;
}
.keywords {
  width: 410px;
  height: 200px;
  border-radius: 5px;
  border: 1px #ccc solid;
}
/deep/.el-tag {
  background-color: #ebf6ff;
  border-color: #ebf6ff;
  color: #0089ef;
  margin: 5px 0 0 5px;
  .el-tag__close {
    color: #0089ef;
    &:hover {
      background-color: #ebf6ff;
    }
  }
}
.button-new-tag {
  background-color: #f9fcff;
  display: inline-block;
  height: 32px;
  padding: 0 10px;
  line-height: 30px;
  font-size: 12px;
  border-width: 1px;
  border-style: solid;
  border-radius: 4px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  white-space: nowrap;
  margin: 5px 0 0 5px;
}
.input-new-tag {
  width: 90px;
  margin: 5px 0 0 5px;
}
</style>
